"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = exports.clearStorageForLogout = exports.setToken = exports.getItem = exports.storeItem = void 0;
const constants_1 = require("../../constants/constants");
const storeItem = (key, val) => {
    try {
        let item = val;
        if (val.constructor === JSON.constructor) {
            item = JSON.stringify(val);
        }
        window.localStorage.setItem(key, item);
    }
    catch (error) {
        console.log(error);
    }
};
exports.storeItem = storeItem;
const getItem = (key) => {
    let item = window.localStorage.getItem(key) || "";
    try {
        return JSON.parse(item);
    }
    catch (error) {
        console.log(error);
    }
};
exports.getItem = getItem;
const setToken = (token) => {
    localStorage.setItem(constants_1.StorageKeys.user_token, token);
};
exports.setToken = setToken;
const clearStorageForLogout = () => {
    // Clear all storage by Storage Keys
    // This prevents to delete all storage
    Object.values(constants_1.StorageKeys).forEach((value) => {
        localStorage.removeItem(value);
    });
};
exports.clearStorageForLogout = clearStorageForLogout;
const getToken = () => localStorage.getItem(constants_1.StorageKeys.user_token);
exports.getToken = getToken;
